import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/filters/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/filtersModel.js
// module id = 13
// module chunks = 0